module.exports = __webpack_public_path__ + "static/media/img_34.79e0697b.JPG";